export const ADOPTION_TYPE_OPTIONS = [
    { value: "inherent", labelKey: "Inherent" },
    { value: "configurable", labelKey: "Configurable" },
    { value: "conditional", labelKey: "Conditional" },
];

/**
 * Catalog-backed AI measures reject adoption changes.
 * Manual measures and AI measures without a catalog key can change it.
 *
 * @param {{ is_ai_generated?: boolean, catalog_key?: string|null }} measure
 * @returns {boolean}
 */
export const isAdoptionTypeLocked = (measure) => {
    return Boolean(measure?.is_ai_generated && measure?.catalog_key);
};

const trimmed = (value) => {
    return typeof value === "string" ? value.trim() : "";
};

export const buildCreateMeasurePayload = (values) => {
    const payload = {
        title: trimmed(values.title),
        measure_type: values.measureType,
    };
    const description = trimmed(values.description);

    if (description) {
        payload.description = description;
    }

    if (values.adoptionType) {
        payload.adoption_type = values.adoptionType;
    }

    return payload;
};

export const buildUpdateMeasurePayload = (values, measure) => {
    const payload = {
        title: trimmed(values.title),
        description: trimmed(values.description),
        measure_type: values.measureType,
    };

    if (!isAdoptionTypeLocked(measure) && values.adoptionType) {
        payload.adoption_type = values.adoptionType;
    }

    return payload;
};
